<template lang='pug'>
  auth-layout
    #forgot-password.view
      bf-notice(:message='message' @close='message = ""')
      transition
        auth-body(v-show='show' key='auth-body')
          h4.heading {{ $t('Enter your email below to reset your password') }}
          form(@submit.prevent='send')
            fieldset
              bf-input
                template(slot='icon')
                  img.img(src='/ui/email-icon.png')
                input( required type='email' :placeholder='$t("Email")' v-model='email' )

            bf-flex.centered
              .back-button
                router-link.text-only(:to='{ name: "sign-in" }') {{ $t('Back') }}
              bf-button.large.combo.solid.submit.light.wide(type='submit')
                template(slot='icon')
                  send-icon.icon
                template(slot='text') {{ $t('Send Reset Email') }}

      auth-body.back-panel(v-show='show' key='back-panel')
</template>

<script>
  import { auth } from '@/main'
  import AuthLayout from '@/layouts/auth'
  import AuthHeader from '@/components/auth-header'
  import AuthBody from '@/components/auth-body'

  import { Animatable } from '@/mixins/view'

  export default {
    name: 'view.forgot-password',

    components: {
      AuthLayout,
      AuthBody,
      AuthHeader
    },

    mixins: [ Animatable ],

    data() {
      return {
        email: '',
        message: '',
        show: false
      }
    },

    methods: {
      send() {
        auth.sendPasswordResetEmail(this.email)
          .then( () => this.message = 'Password-reset email is sent!' )
          .catch( e => this.message = e )
      }
    }
  }

</script>

<style scoped lang='stylus'>
  #forgot-password
    .heading
      text-align center
      margin-bottom 32px
      @media(max-width: 640px)
        font-size .9em
    .bf-button
      margin-top 32px
      margin-right auto
    .back-panel
      top 12px
    .back-button
      margin-right auto
      text-align left
      margin-top 32px
    .bf-input .img
      margin-top 5.5px
</style>
